<template>
  <div id="personInfo">
    <Nav v-if="PsjID" />
    <div class="step-box step-box2" v-else>
      <!-- <img src="https://ef-eztm.oss-cn-beijing.aliyuncs.com/ezt-img/2920/en1.png" width="100%"> -->
      <img :src="en1" width="100%">
    </div>
    <div class="personInfobox" :style="syStyle" style="position: relative;">
      <h3 class="title">Fill in personal information</h3>
      <el-form :model="ruleForm2" ref="ruleForm" label-width="100px" class="demo-ruleForm from-wrap">
        <div @click="showEmailTip=false">
          <div>
            <!-- 头像 -->
            <div
              style='text-align:left;'
              class="form-item"
              label="Photo"
              prop=""
              v-if="PhotoModel"
            >
              <div>Photo<b v-if="IsRequiredPhoto" style="color: red">*</b></div>
              <div style="width:100%; text-align:center;">
                <img :src="pmp" style="width:150px;" v-if="!photoImg" alt="" @click="uploadPicture('flagImg')">
                <span class="photoImg" v-else>
                  <img :src="photoImg" style="width:120px;" alt="" @click="uploadPicture('flagImg')">
                  <div class="photoBtns">
                    <el-button size="small" @click="deletePhoto">Delete</el-button>
                    <el-button size="small" @click="uploadPicture('flagImg')">Re upload</el-button>
                  </div>
                </span>
              </div>
            </div>
          </div>
          <div v-for="(item,index) in inputCofigData" :key="index">
            <!-- 姓名 -->
            <div
              class="form-item"
              :label="item.Etitle"
              prop="rgname"
              v-if="item.name==='PsnName'&&item.optional"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('userName')"
                v-model="ruleForm2.userName"
                :name="item.name"
                :placeholder="item.Eplaceholder"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 公司 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnComName'&&item.optional"
              prop="rgComName"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('comName')"
                v-model="ruleForm2.comName"
                :name="item.name"
                :placeholder="item.Eplaceholder"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 性别 -->
            <div
              class="form-item sex"
              :label="item.Etitle"
              prop="rgSex"
              v-if="item.name==='PsnGender'&&item.optional"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-radio v-model="ruleForm2.sex" checked label="先生" @change="cacheInput">先生</el-radio>
              <el-radio v-model="ruleForm2.sex" label="女士" @change="cacheInput">女士</el-radio>
            </div>
            <!-- 职务 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnRank'&&item.optional"
              prop="rgRank"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('rank')"
                v-model="ruleForm2.rank"
                :name="item.name"
                :placeholder="item.Eplaceholder"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 部门 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnDept'&&item.optional"
              prop="rgDepar"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('depar')"
                v-model="ruleForm2.depar"
                :name="item.name"
                :placeholder="item.Eplaceholder"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 手机 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnMobile'&&item.optional"
              prop="rgIphone"
            >
              <div>
                {{item.Etitle}}
              </div>
              <el-input
                type="number"
                v-model="ruleForm2.iphone"
                @keyup.native="clearSpace('iphone')"
                :placeholder="item.Eplaceholder"
                maxlength="11"
                :name="item.name"
              ></el-input>
            </div>
            <!-- 国家 -->
            <div
              class="form-item"
              :label="item.Etitle"
              prop="rgEmptyCountry"
              v-if="showCountry&&item.name==='PsnCountry'&&item.optional"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-select
                v-model="ruleForm2.country"
                :loading="isLoading"
                @visible-change="loadCountry"
                @change="changeCountry"
                :placeholder="item.Eplaceholder"
                :name="item.name"
              >
                <el-option label="China" value="086"></el-option>
                <el-option
                  v-for="(item,index) in countryArr"
                  :label="item.zptECity"
                  :value="item.zptCityCode"
                  :key="index"
                ></el-option>
              </el-select>
            </div>
            <!-- 地址 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name=='PsnAddress'&&item.optional"
              prop="rgAddr"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @blur="clearSpace('addr')"
                v-model="ruleForm2.addr"
                :placeholder="item.Eplaceholder"
                :name="item.name"
                error="dsfs"
                maxlength="50"
              ></el-input>
            </div>
            <!-- 邮箱 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnEmail'&&item.optional"
              prop="rgEmeil"
              :hide-required-asterisk="item.required"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="50"
                :name="item.name"
                @keyup.native.space="clearSpace('email')"
                v-model="ruleForm2.email"
                :placeholder="item.Eplaceholder"
                @input="changeEmail"
               :disabled="true"
                error
              ></el-input>
              <div class="email-tip" v-if="item.name==='PsnEmail'&&showEmailTip">
                <div
                  class="email-tip-option"
                  v-for="(item,index) in emailArr"
                  :key="index"
                  @click="chooseEmailSuffix(item)"
                >{{ruleForm2.email.split('@')[0]+item}}</div>
              </div>
            </div>
            <!-- 网址 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnWebUrl'&&item.optional"
              prop="rgWebUrl"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="50"
                :name="item.name"
                @keyup.native.space.passive="clearSpace('webUrl')"
                :placeholder="item.Eplaceholder"
                v-model="ruleForm2.webUrl"
                class="input-with-select"
                @change="cacheInput"
              ></el-input>
            </div>
            <!-- 传真 -->
            <div
              class="form-item tel"
              :label="item.title"
              v-if="item.name==='PsnFax'&&item.optional"
              prop="rgFax"
            >
              <div>
                {{item.title}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <div style="width:88%;display: flex;">
                <el-input
                  @keyup.native="clearSpace('gNum')"
                  style="width: 30%;min-width: 66px;"
                  v-model="ruleForm2.gNum"
                  placeholder="Country code"
                  maxlength="4"
                ></el-input>-
                <el-input
                  @keyup.native="clearSpace('cNum')"
                  style="width: 30%;min-width: 66px;"
                  v-model="ruleForm2.cNum"
                  placeholder="Area code"
                  maxlength="11"
                  v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'"
                ></el-input>
                <span v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'">-</span>
                <el-input
                  @keyup.native="clearSpace('faxNum')"
                  v-model="ruleForm2.faxNum"
                  placeholder="Fax code"
                  :name="item.name"
                  class="tel"
                ></el-input>
              </div>
            </div>
            <!-- 座机 -->
            <div
              class="form-item tel"
              :label="item.Etitle"
              v-if="item.name==='PsnTel'&&item.optional"
              prop="rgTel"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <div style="width:88%;display: flex;">
                <el-input
                  @keyup.native="clearSpace('gNum')"
                  style="width: 30%;min-width: 66px;"
                  v-model="ruleForm2.gNum"
                  placeholder="Country code"
                  maxlength="4"
                ></el-input>-
                <!-- -<el-input
                  @keyup.native="clearSpace('cNum')"
                  style="width: 30%;min-width: 66px;"
                  v-model="ruleForm2.cNum"
                  placeholder="Area code"
                  maxlength="11"
                  v-if="ruleForm2.gNum === '086'||ruleForm2.gNum === '86'"
                ></el-input> -->
                <!-- <span v-if="ruleForm2.gNum=='086'||ruleForm2.gNum=='86'" style="display: inline-block;line-height: 50px">-</span> -->
                <el-input
                  @keyup.native="clearSpace('telNum')"
                  v-model="ruleForm2.telNum"
                  placeholder="Fax code"
                  :name="item.name"
                  class="tel"
                ></el-input>
              </div>
            </div>
            <!-- 行业 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnTrade'&&item.optional"
              prop="rgEmptyIndustry"
              palceholder="请选择行业"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-select v-model="ruleForm2.industry" @change="cacheInput" :name="item.name" :placeholder="item.Eplaceholder">
                <!-- <el-option v-for="(item,index) in item.data" :key="index" :label="item" :value="item"></el-option> -->
                <el-option v-for="(item,index) in tradeOptions" :key="index" :label="item" :value="item"></el-option>
              </el-select>
            </div>
            <!-- 身份证 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnIDCard'&&item.optional"
              prop="rgCId"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="18"
                :name="item.name"
                @keyup.native.space.passive="clearSpace('cId')"
                v-model="ruleForm2.cId"
                :placeholder="item.Eplaceholder"
                @change="cacheInput"
              ></el-input>
            </div>
            <!-- pass -->
            <!-- <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name==='PsnLoginPwd'&&item.optional"
              prop="rgPassword"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="18"
                @keyup.native.space.passive="clearSpace('password')"
                type="password"
                v-model="ruleForm2.password"
                :placeholder="item.Eplaceholder"
                @change="cacheInput"
                :name="item.name"
              ></el-input>
            </div> -->
            <!-- 确认密码 -->
            <!-- <div
              class="form-item"
              label="确认密码"
              v-if="item.name==='PsnLoginPwd'&&item.optional"
              prop="confirmPassword"
            >
              <div>
                确认密码
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                maxlength="18"
                @keyup.native.space.passive="clearSpace('confirmPassword')"
                type="password"
                v-model="confirmPassword"
                placeholder="请再次输入密码"
                @change="cacheInput"
                name="confirmPassword"
              ></el-input>
            </div> -->
            <!-- 邮编 -->
            <div
              class="form-item"
              :label="item.Etitle"
              v-if="item.name=='PsnZipCode'&&item.optional"
              prop="rgPostcode"
            >
              <div>
                {{item.Etitle}}
                <b v-if="item.required" style="color: red">*</b>
              </div>
              <el-input
                @keyup.native.space.passive="clearSpace('postcode')"
                v-model="ruleForm2.postcode"
                :placeholder="item.Eplaceholder"
                @change="cacheInput"
                :name="item.name"
              ></el-input>
            </div>
          </div>
          <div>
            <div label="Appointment date" prop="rgCId" class="form-item">
              <div>
                Appointment date
                <b style="color: red;">*</b>
              </div>
              <div class="radioBox">
                <el-checkbox-group v-model="chooseDate" class="dateChecks">
                  <el-checkbox-button v-for="(item,index) in Datelist" :label="item.SetID" :disabled="item.IsEnable == '0'" :key="index">
                    <span style="display: block; margin-bottom: 5px;">{{ item.SetKey }}</span>
                    <span>{{ item.SetValue }}</span>
                  </el-checkbox-button>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <!-- 授权 -->
          <div class="privacySwitch" v-if="privacySwitch&&privacyInfo">
            <el-checkbox v-model="isChecked"></el-checkbox>
            <div class="privacyTxt" @click="showPrivacyInfo">I agree and accept the Private Policy of CFAA</div><!-- v-html="PrivacyTitle" -->
            <!-- <div class="privacyTxt" v-html="privacyInfo"></div> -->
          </div>
          <!-- 防疫 -->
          <!-- <div class="privacySwitch" v-if="privacySwitch&&FangyiInfo">
            <el-checkbox v-model="isChecked"></el-checkbox>
            <div class="privacyTxt" v-html="FangTitle" @click="showFangyiInfo"></div>
            <div class="privacyTxt" v-html="FangyiInfo"></div>
          </div> -->
          <!-- 后台配置两个免责声明 2019.01.15添加-->
          <el-row v-if="statement1" style="padding:10px 14px; margin-top:20px;">
            <label>
              <el-checkbox v-model="statement1.value">
                <span id="PsnExtField1" style="margin-left: 10px;color:#136ec2;text-decoration: underline;">{{statement1.Etitle}}</span>
              </el-checkbox>
            </label>
          </el-row>
          <!-- 后台配置两个免责声明2 -->
          <el-row v-if="statement2" style="padding:0 14px">
            <label>
              <el-checkbox v-model="statement2.value">
                <span id="PsnExtField2" style="margin-left: 10px;color:#136ec2;text-decoration: underline;">{{statement2.Etitle}}</span>
              </el-checkbox>
            </label>
          </el-row>
          <el-button
            :style="btnAllStyle"
            type="primary"
            class="Personinfo-submit-btn"
            :loading="showBtnLoading"
            @click="submit('ruleForm')"
          >{{PsjID? 'Save': 'Next'}}</el-button>
        </div>
      </el-form>
      <div style="position: absolute;width: 100%;left: 0%;bottom: 0rem;top:0%;background: rgba(0,0,0,.5);z-index: 9;overflow-y: auto;" v-if="showPInfro">
        <div class="privacyTxt" style="padding: 20px;border: 1px solid #cdcdcd;border-radius: 20px;background: #fff;margin: 1rem auto 0;width: 90%;">
           <!-- v-html="privacyInfo" -->
          <p class="MsoNormal" style="background:#FFFFFF;">
            <br />
          </p>
          <p class="MsoNormal">
            Privacy Policy<br />
          <br />
          CFAA Convention &amp; Exhibition Company(Here after We) respect and protect the privacy of all users of our services. In order to provide you with more accurate and personalized services, we will use and disclose your personal information in accordance with the provisions of this Privacy Policy. However, we will treat such information with a high degree of diligence and prudence. Except as otherwise provided in this Privacy Policy, we will not disclose such information to the public or provide it to third parties without your prior permission. We will update this Privacy Policy from time to time. By agreeing to the Service Usage Agreement, you are deemed to have agreed to all contents of this Privacy Policy.<br />
          <br />
          1. Scope of Application<br />
          a) The personal mobile number provided according to the requirements of FIC users when you register as a FIC user.<br />
          b) We will collect your personal and company information, including but not limited to your name, company, department, position, email, contact information, etc. when you use FIC Visitor Services.<br />
          c) We obtain the personal data of users legally from our business partners.<br />
          <br />
          You understand and agree that the following information is not subject to this Privacy Policy:Acts in violation of the law or our rules and measures we have taken against you.<br />
          <br />
          2.Use of Information<br />
          a)We will not provide, sell, rent, share or trade your personal and corporate information to any unrelated third party, unless you have prior permission, or such third party and us (including our affiliates) provide services for you individually or jointly, and they will be prohibited from accessing all such information, including those they have previously been able to access after the termination of service.<br />
          b) We also do not allow any third party to collect, edit, sell or distribute your personal and corporate information by any means. If any user of our platform engages in the above activities, we have the right to immediately terminate the service agreement with such users upon discovery.<br />
          c) For the purpose of serving users, we may provide you with information of interest to you by using your personal information, including but not limited to sending you information about products and services, or share information with our partners so that they can send you information about their products and services (the latter requires your prior consent).<br />
          <br />
          3.Information Disclosure<br />
          Under the following circumstances, we will disclose your personal information in whole or in part according to your personal will or the provisions of the law:<br />
          a)Disclose to third parties with your prior consent;<br />
          b)Share your personal information with third parties in order to provide the products and services you require;<br />
          c)To disclose to a third party or an administrative or judicial organ in accordance with the relevant provisions of the law or at the request of an administrative or judicial organ;<br />
          d)Your information are required to disclose to a third party if you violate relevant Chinese laws and regulations or our service agreement or relevant rules.<br />
          e)If you are a qualified IPR complainant and have filed a complaint, your information is disclosed to the respondent so that both parties can deal with possible rights disputes at the request of the respondent;<br />
          f)Other disclosures we deem appropriate in accordance with laws, regulations, or website policies.<br />
          <br />
          4. Information Storage and Exchange<br />
          Your information and data collected by us will be stored in our and/or third-party cloud servers, and such information and data may be sent to your country, region or outside the country where we collect the information and data and be accessed, stored and displayed outside the country.
          </p>
          <div>
            <br />
          </div>
          <p>
            <br />
          </p>
          <p class="MsoNormal" style="margin-left:-18.0000pt;">
            <br />
          </p>
          <p>
            <br />
          </p>
		</div>
        <div>
          <el-button
            :style="btnAllStyle"
            type="primary"
            class="Personinfo-submit-btn"
            :loading="showBtnLoading"
            @click="closePInfo"
            style="margin-top: 10px !important;"
          >Confirm</el-button>
        </div>
      </div>
    </div>
    <!-- 剪裁组件弹窗 -->
    <el-dialog
      title="Select photo"
      :visible.sync="cropperModel"
      width="800px"
      center
      >
     <cropper-image
      :Name="cropperName"
      @uploadImgSuccess = "handleUploadSuccess"
      ref="child">
     </cropper-image>
    </el-dialog>
    <!--查看头像-->
    <el-dialog
        title="头像"
        :visible.sync="imgVisible"
        center>
      <img :src="imgName" v-if="imgVisible" style="width: 100%" alt="查看">
    </el-dialog>
  </div>
</template>
<script>
import api from '../api'
import utils from '../utils'
import regExp from '../utils/regExp.js'
import Nav from '../components/Nav'
import CropperImage from '../components/CropperImage.vue';
import pmp from '../../static/img/pmp.png'
import en1 from '../../static/img/en1.png'
export default {
  name: 'BasicInfo',
  components: {
    Nav,
    CropperImage
  },
  data() {
    return {
      en1: en1,
      inputCofigData: [], // input 标签配置数据
      showBtnLoading: false, // load btn
      ruleForm2: {
        tabindex: 1,
        industry: '', // 行业
        userName: '', // 姓名
        comName: '', // 公司名
        sex: '',
        rank: '', // 职务
        depar: '', // 部门
        iphone: '',
        code: '', // 验证码
        email: '',
        webUrl: '',
        gNum: '', // 国家号前缀 :86
        gNum1: '',
        cNum: '', // 城市号前缀： 0312
        faxNum: '', // 传真座机号
        telNum: '', // 座机号
        cId: '', // 身份证号
        postcode: '', // 邮编
        remark: '', // 备注
        password: '',
        country: '',
        province: '',
        city: '',
        telGnum: '',
        addr: '',
        authorization: false
      },
      emailCopy: '',
      emailArr: [
        '@qq.com',
        '@163.com',
        '@126.com',
        '@yeah.net',
        '@vip.sina.com',
        '@sina.com',
        '@msn.com',
        '@hotmail.com',
        '@aol.com',
        '@ask.com',
        '@live.com'
      ],

      stepNum: 1,
      showCodeBtn: false, // 显示 code btn
      codeText: '获取验证码',
      countryArr: [], // 国家 or 特区 Arr
      provinceArr: [], // 省
      cityArr: [], // 城市
      tradeOptions:['Mainland Travel Permit for Hong Kong and Macao Residents','Mainland Travel Permit for Taiwan Residents','Passport','Foreign Permanent Resident Id Card'],
      showCountry: true, // 默认显示
      showProvince: false, //
      showCity: false,
      rg: /[0-9]{11}/,
      radio: 1, // 男女
      selectHttp: 'https:// ', // 选择协议
      showEmailTip: false,
      privacySwitch: false, // 是否显示 授权信息;
      PrivacyTitle: '', // 授权标题
      privacyInfo: '', // 授权信息
      FangTitle: '', // 防疫标题  
      FangyiInfo: '', // 防疫信息
      isChecked: true,
      ExhID: sessionStorage.getItem('ExhID'),
      PsjID: sessionStorage.getItem('PsjID'),
      IfSubmit: false,
      isLoading: false,
      previousEmail: '',
      isConsistencyIdCard: sessionStorage.getItem('isConsistencyIdCard') || '',
      syStyle: JSON.parse(sessionStorage.getItem('syStyle')) || {},
      confirmPassword: '', // 确认密码
      stepImg: [],
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {},
      isRepeatIDCard: sessionStorage.getItem('isCheckIDCard') && sessionStorage.getItem('isCheckIDCard') === 'true',
      PhotoModel: JSON.parse(sessionStorage.getItem('PhotoModel')) || false,
      photoImg: sessionStorage.getItem('regPhoto') || '',
      IsRequiredPhoto: JSON.parse(sessionStorage.getItem('IsRequiredPhoto')) || false,
      pmp: pmp,
      // 裁切图片参数
      cropperModel: false,
      cropperName: '',
      imgName: '',
      imgVisible: false,
      statement1: '',
      statement2: '',
      statmentCon1: '',
      statmentCon2: '',
      DisclaimerContent: '',
      showPInfro: false,
      Datelist: [], // 日期列表
      chooseDate: ['1143', '1144', '1145'] // 选中日期
    }
  },
  computed: {
    faxNumber: function() {
      // 传真号全拼
      var str = ''
      if (this.ruleForm2.gNum === '086') {
        str =
          this.ruleForm2.gNum +
          '-' +
          this.ruleForm2.cNum +
          '-' +
          this.ruleForm2.faxNum
      } else {
        str = this.ruleForm2.gNum + '-' + this.ruleForm2.faxNum
      }
      return str
    },
    telNumber: function() {
      var str = ''
      if (this.ruleForm2.gNum === '086') {
        str =
          this.ruleForm2.gNum +
          // '-' +
          // this.ruleForm2.cNum +
          '-' +
          this.ruleForm2.telNum
      } else {
        str = this.ruleForm2.gNum + '-' + this.ruleForm2.telNum
      }
      return str
    }
  },
  mounted() {
    this.loadPageConfig() // 页面配置
    this.loadInputConfig() // input 配置
    this.initData()
    this.loadCountry(true)
    if (sessionStorage.getItem('stepImg')) {
      this.stepImg = JSON.parse(sessionStorage.getItem('stepImg'))
    } else {
      this.stepImg = []
    }
    utils.setThemeColor()
    this.getDates()
    if (this.PsjID) {
      this.GetVisiteDateHandler()
    }
  },
  methods: {
    async GetVisiteDateHandler () {
      console.log(11111)
      const res = await api.GetVisiteDateByPsjID({
        ExhID: this.ExhID,
        PsjID: sessionStorage.getItem('PsjID')
      })
      if (res.data.status === 'OK') {
        this.chooseDate = []
        res.data.Data.map(itme => {
          this.chooseDate.push(itme.ParentID)
        });
        // this.chooseDate = res.data.Data
      } else {
        this.$alert(res.data.ErrorEMsg, 'Tips')
      }
    },
    getDates() {
      api.GetDatalist({ExhID: this.ExhID}).then(res => {
        if (res.data.status === 'OK') {
          this.Datelist = res.data.Data
        } else {
          this.$alert(res.data.ErrorMsg, '提示')
          // this.$alert(res["data"]["ErrorMsg"], '提示', {
          //   confirmButtonText: '确定',
          //   closeOnClickModal: true,
          //   type: 'error'
          // });
          // common.themeStyleUniform();
          this.isLoading = false
        }
      });
    },
    showPrivacyInfo() {
      this.showPInfro = true
    },
    closePInfo() {
      this.showPInfro = false
    },
    // 删除头像
    deletePhoto() {
      this.photoImg = ''
    },
    // 头像设置
    uploadPicture(name) {
      this.cropperName = name;
      this.cropperModel = true;
    },
    // 图片上传成功后
    handleUploadSuccess (data) {
      this.photoImg = data
      sessionStorage.setItem('regPhoto', data)
      this.cropperModel = false;
    },
    clearSpace(n) {
      var obj = this.ruleForm2
      if (
        n === 'userName' ||
        n === 'comName' ||
        n === 'rank' ||
        n === 'depar' ||
        n === 'addr'
      ) {
        obj[n] = obj[n].trim()
      } else if (
        n === 'iphone' ||
        n === 'code' ||
        n === 'gNum' ||
        n === 'faxNum' ||
        n === 'cNum' ||
        n === 'telNum'
      ) {
        // 数字
        obj[n] = obj[n].replace(/\D/g, '')
      } else {
        obj[n] = obj[n].replace(/\s+/gim, '')
      }
      this.ruleForm2 = obj
      this.cacheInput()
      return false
    },
    initData() {
      // 载页面  数据初始化
      var obj = this.ruleForm2
      var uName = sessionStorage.getItem('cacheRegiater') || sessionStorage.getItem('cacheLogin')
      var uAddr = sessionStorage.getItem('cacheAdress')
      var cacheInfo = sessionStorage.getItem('cacheInfo')
      uName = JSON.parse(uName)
      uAddr = JSON.parse(uAddr)
      // 再次登陆，已注册，但未缓存数据
      if (this.PsjID) {
        api
          .getRegistInfo({
            ExhID: this.ExhID,
            PsjID: this.PsjID
          })
          .then(res => {
            if (res.data.status === 'OK') {
              var data = res.data.Data
              var obj = this.ruleForm2
              obj.addr = data.PsnAddress
              obj.city = data.PsnCity
              obj.comName = data.PsnComName
              obj.country = data.PsnCountry
              obj.province = data.PsnProvince
              obj.depar = data.PsnDept
              obj.email = data.PsnEmail
              // console.log(data.PsnFax === null, 'gggg')
              if (data.PsnFax !== null) {
                obj.faxNum = data.PsnFax.indexOf('-') > -1 ? data.PsnFax.split('-')[data.PsnFax.split('-').length - 1] : data.PsnFax
              }
              if (data.PsnTel !== null) {
                obj.telNum = data.PsnTel.indexOf('-') > -1 ? data.PsnTel.split('-')[data.PsnTel.split('-').length - 1] : data.PsnTel
              }
              obj.sex = data.PsnGender
              obj.cId = data.PsnIDCard
              obj.password = data.PsnLoginPwd
              obj.iphone = data.PsnMobile
              obj.userName = data.PsnName
              obj.rank = data.PsnRank
              obj.remark = data.PsnRemark
              obj.industry = data.PsnTrade
              obj.webUrl = data.PsnWebUrl
              obj.postcode = data.PsnZipCode
              this.photoImg = data.PhotoUrl
              if (obj.country === 'China') {
                obj.gNum = '086'
                if (data.PsnTel && data.PsnTel.indexOf('-') > -1) {
                  let arr = data.PsnTel.split('-')
                  if (arr.length === 3) {
                    obj.cNum = arr[1]
                  }
                } else if (data.PsnFax && data.PsnFax.indexOf('-') > -1) {
                  let arr = data.PsnFax.split('-')
                  if (arr.length === 3) {
                    obj.cNum = arr[1]
                  }
                }
              } else {
                if (data.PsnTel && data.PsnTel.indexOf('-') > -1) {
                  obj.gNum = data.PsnTel.split('-')[0]
                } else if (data.PsnFax && data.PsnFax.indexOf('-') > -1) {
                  obj.gNum = data.PsnFax.split('-')[0]
                }
              }
              this.ruleForm2 = obj
            }
            this.previousEmail = this.ruleForm2.email
          })
      }
      // 首次进入 未注册
      if (!this.PsjID && obj.email === '' && !cacheInfo) {
        var param = {
          ExhID: this.ExhID,
          Email: uName.email ? uName.email : ''
        }
        //  获取往届信息
        api.getPeronInfo(param).then(res => {
          if (res.data.status === 'OK') {
            obj.userName = uName.userName
            obj.comName = res.data.PsnComName
            obj.sex = res.data.PsnGender
            obj.rank = res.data.PsnRank
            obj.depar = res.data.PsnDept
            obj.iphone = res.data.PsnMobile
            // obj.iphone = uName.iphone
            // obj.email = res.data.PsnEmail
            obj.email = uName.email

            // cache for checking email change or not in edit mode
            this.previousEmail = res.data.PsnEmail

            obj.webUrl = res.data.PsnWebUrl

            obj.telGnum = obj.gNum = res.data.PsnTel.split('-')[0]
            let faxNumIndex = res.data.PsnFax.split('-').length - 1
            obj.faxNum = res.data.PsnFax.split('-')[faxNumIndex]
            let telNumIndex = res.data.PsnTel.split('-').length - 1
            obj.telNum = res.data.PsnTel.split('-')[telNumIndex]
            obj.cId = res.data.PsnIDCard
            obj.postcode = res.data.PsnZipCode
            obj.country = res.data.PsnCountry
            obj.province = res.data.PsnProvince
            obj.city = res.data.PsnCity
            this.ruleForm2 = obj
          } else {
            // 没有往届信息
            obj.userName = uName.userName ? uName.userName : ''
            obj.email = uName.email ? uName.email : ''
            if (uAddr && uAddr.MadProvince && uAddr.MadCity) {
              obj.telGnum = obj.gNum = '086'
              obj.cNum = uAddr.MadCityCode ? uAddr.MadCityCode : ''
              obj.country = '中国大陆'
              obj.province = uAddr.MadProvince ? uAddr.MadProvince : ''
              obj.city = uAddr.MadCity ? uAddr.MadCity : ''
            }

            this.ruleForm2 = obj
          }
          this.$store.commit('setUserInfo', obj)
          sessionStorage.setItem('cacheInfo', JSON.stringify(obj))
        })
      } else {
        // 非第一加载
        if (cacheInfo) {
          obj = JSON.parse(cacheInfo)
          obj.email = uName.email
          this.ruleForm2 = obj
          this.previousEmail = this.ruleForm2.email
        }
      }
    },
    changeEmailOnce() {
      var isT = false
      this.cacheInput()
      return function() {
        if (isT) {
          if (this.ruleForm2.email) {
            this.showEmailTip = true
          } else {
            this.showEmailTip = false
          }
        } else {
          isT = true
        }
      }
    },
    changeEmail() {
      this.cacheInput()

      if (this.ruleForm2.email && this.ruleForm2.email.indexOf('@') < 0) {
        this.showEmailTip = true
      } else {
        this.showEmailTip = false
      }
    },
    chooseEmailSuffix(str) {
      this.ruleForm2.email = this.ruleForm2.email.split('@')[0] + str
      this.cacheInput()
      this.showEmailTip = false
    },
    cacheInput(str) {
      if (str === 'province') {
        var obj = this.ruleForm2
        obj.city = ''
        this.ruleForm2 = obj
      }
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },

    loadCity(v) {
      var param = {
        ExhID: this.ExhID,
        zptProvince: this.ruleForm2.province
      }
      api.getCity(param).then(res => {
        if (res.data.status === 'OK') {
          var data = res.data.Data
          this.cityArr = data
        }
      })
    },
    changeCity(v) {
      var obj = this.ruleForm2
      var event = window.event
      var target = event.target || event.srcElement
      obj.cNum = v
      obj.city = target.innerText
      this.ruleForm2 = obj
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },
    changeCountry(v) {
      var obj = this.ruleForm2
      obj.gNum1 = obj.gNum = obj.telGnum = v
      var event = window.event
      var target = event.target || event.srcElement
      obj.country = target.innerText
      if (target.innerText && target.innerText !== '中国大陆') {
        this.ruleForm2.province = ''
        this.ruleForm2.city = ''
      }
      this.ruleForm2 = obj
      sessionStorage.setItem('cacheInfo', JSON.stringify(this.ruleForm2))
    },
    loadProvince(v) {
      var param = {
        ExhID: this.ExhID
      }
      api.getProvince(param).then(res => {
        var data = res.data.Data
        if (data && data.length > 0) {
          this.provinceArr = data
          this.showProvince = true
        } else {
          this.provinceArr = []
          this.cityArr = []
        }
      })
    },
    loadCountry(v) {
      // 加载国家
      if (!v) {
        return ''
      }
      var param = {
        ExhID: this.ExhID,
        Lan: 'en'
      }
      api.getCountry(param).then(res => {
        if (res.data.status === 'OK') {
          var data = res.data.Data
          var arr = []
          for (var i = 0; i < data.length; i++) {
            arr.concat(data[i])
          }
          this.countryArr = data
        } else {
          this.$alert(res.data.ErrorMsg)
        }
        this.isLoading = false
      })
    },
    loadPageConfig: function() {
      console.log(11111)
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'AddInfo',
        Language: 'cn'
      }
      api.getPage(param).then(res => {
        if (res.data.status === 'OK') {
          console.log('getpage')
          var switchInfos = res.data.switchInfos
          for (let i = 0; i < switchInfos.length; i++) {
            switch(switchInfos[i].name) {
              case 'IfSubmit':
                this.IfSubmit = switchInfos[i].data;
                sessionStorage.setItem('IfSubmit', this.IfSubmit);
                break;
              case 'PrivacySwitch':
                this.privacySwitch = switchInfos[i].data
                break;
            }
          }
          var promptinfo = res.data.promptinfo

          for (let i = 0; i < promptinfo.length; i++) {
            if (promptinfo[i].name === 'PrivacyTitle') {
              this.PrivacyTitle = promptinfo[i].value
            }
            if (promptinfo[i].name === 'PrivacyInfo') {
              this.privacyInfo = promptinfo[i].value
            }
            if (promptinfo[i].name === 'FangTitle') {
              this.FangTitle = promptinfo[i].value
            }
            if (promptinfo[i].name === 'FangyiInfo') {
              this.FangyiInfo = promptinfo[i].value
            }
            console.log(this.PrivacyTitle,947)
          }
        } else {
          this.$alert(res.data.ErrorMsg)
        }
      })
    },
    loadInputConfig() {
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      var param = { ExhID: this.ExhID, RegistType: 'pc' }

      api.getinput(param).then(res => {
        if (res.data.status === 'OK') {
          this.inputCofigData = res.data.data.sort(this.sequence)
          console.log(this.inputCofigData, '968')
          this.inputCofigData.map(itme => {
            if (itme.name === 'PsnExtField1' && itme.optional) {
              this.statement1 = itme
              // 初始值为否
              this.statement1.value = false
            }
            if (itme.name === 'PsnExtField2' && itme.optional) {
              this.statement2 = itme
              this.statement2.value = false
            }
          });
          console.log(this.statement1, this.statement2, 'ghhgh')
          loading.close()
        }
      })
    },
    showTips(name) {
      this.modals = true
      if(name === 'statement1') {
        this.DisclaimerContent = this.statmentCon1
      }
      if(name === 'statement2') {
        this.DisclaimerContent = this.statmentCon2
      }
    },
    sequence (a, b) {
      if (parseInt(a.BisSort) > parseInt(b.BisSort)) {
        return 1;
      } else if (parseInt(a.BisSort) < parseInt(b.BisSort)) {
        return -1
      } else {
        return 0;
      }
    },
    checkRepeatEmailCidCode(cb) {
      var param = {
        PsnEmail: this.ruleForm2.email,
        ExhID: this.ExhID
      }
      api.emailRepeat(param).then(res => {
        if (res.data.status === 'OK') {
          cb()
        } else {
          this.$alert(res.data.ErrorMsg, 'Tips', {
            dangerouslyUseHTMLString: true
          })
        }
      })
    },
    submitInfo() {
      var obj = this.ruleForm2
      this.ruleForm2.PsnExtField1 = this.statement1.value ? '是' : '否';
      this.ruleForm2.PsnExtField2 = this.statement2.value ? '是' : '否'
      this.showBtnLoading = true
      var param = {
        ExhID: this.ExhID,
        WapToken: sessionStorage.token,
        IfSubmit: this.IfSubmit,
        FaceID: '',
        RegistType: 'pc',
        InviteID: sessionStorage.getItem('InviteID')
          ? sessionStorage.getItem('InviteID')
          : 0,
        InviteType: sessionStorage.getItem('InviteType')
          ? sessionStorage.getItem('InviteType')
          : '',
        InviteCode: sessionStorage.getItem('InviteCode')
          ? sessionStorage.getItem('InviteCode')
          : '',
        PsnMobile: obj.iphone,
        PsnName: obj.userName,
        PsnComName: obj.comName,
        PsnGender: obj.sex,
        PsnRank: obj.rank,
        PsnDept: obj.depar,
        PsnCountry: obj.country,
        PsnEmail: obj.email,
        PsnWebUrl: obj.webUrl,
        PsnFax: obj.faxNum ? this.faxNumber : '',
        PsnTel: obj.telNum ? this.telNumber : '',
        PsnTrade: obj.industry,
        PsnIDCard: obj.cId,
        PsnLoginPwd: obj.password,
        PsnZipCode: obj.postcode,
        PsnRemark: obj.remark,
        PsnProvince: obj.province,
        PsnCity: obj.city,
        PsnCode: obj.code,
        PsnAddress: obj.addr,
        PsnCountryCode: obj.gNum1 === '086' ? obj.gNum1.slice(1) : obj.gNum1,
        PhotoUrl: this.photoImg,
        PsnExtField1: obj.PsnExtField1,
        PsnExtField2: obj.PsnExtField2,
        Language: 'en',
        PsnMsn: this.chooseDate.join(',')
      }
      if (this.PsjID) {
        param.EntryPsjId = this.PsjID
        api.updateVisitor(param).then(res => {
          this.showBtnLoading = false
          if (res.data.status === 'OK') {
            this.$alert('Update successful！', 'Tips')
            //  location.reload()
          } else {
            this.$alert(res.data.ErrorMsg, 'Tips')
          }
        })
      } else {
        // 保存信息，跳转问卷
        // sessionStorage.setItem('saveObj', JSON.stringify(this.ruleForm2))
        // this.$router.push({
        //   path: 'questionnaire',
        //   query: { ExhID: this.ExhID, photoImg: this.photoImg }
        // })
        api.saveVisitor(param).then(res => {
          this.showBtnLoading = false
          if (res.data.status === 'OK') {
            sessionStorage.PsnMobile = param.PsnMobile
            sessionStorage.setItem('dataInfo', JSON.stringify(param))
            if (res.data.PsjID) {
              if (sessionStorage.getItem('IsRegistActivity') && sessionStorage.getItem('IsRegistActivity') === 'true') { // 如果有会议跳转到选择会议页面
                this.$router.push({
                  path: 'meeting',
                  query: { ExhID: this.ExhID }
                })
              } else {
                this.$router.push({
                  path: 'confirmation',
                  query: { ExhID: this.ExhID }
                })
              }
              sessionStorage.setItem('PsjID', res.data.PsjID)
            } else {
              this.$router.push({
                path: 'questionnaire',
                query: { ExhID: this.ExhID }
              })
            }
          } else {
            // this.$alert(res.data.ErrorMsg, 'Tips')
            this.$alert(res.data.ErrorEMsg, 'Tips')
          }
        })
      }
    },
    async submit(elemRef) {
      var arr = this.inputCofigData
      var obj = this.ruleForm2
      if (this.IsRequiredPhoto && !this.photoImg) { // 头像必填
        this.$alert('Please upload photo')
        return false;
      }
      for (var i = 0; i < arr.length; i++) {
        var o = arr[i]
        if (o.name === 'PsnName') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.userName)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.userName.length < 2) {
              this.$alert(o.Etitle + 'length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckCnName.test(obj.userName) &&
              !regExp.regCheckEnName.test(obj.userName)
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.userName && obj.userName.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckCnName.test(obj.userName) &&
              !regExp.regCheckEnName.test(obj.userName) &&
              obj.userName
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.userName = ''
          }
        } else if (o.name === 'PsnComName') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.comName)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.comName.length < 4) {
              this.$alert(o.Etitle + ' length cannot be less than 4 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckComName.test(obj.comName)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.comName && obj.comName.length < 4) {
              this.$alert(o.Etitle + ' length cannot be less than 4 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckComName.test(obj.comName) &&
              obj.comName
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.comName = ''
          }
        } else if (o.name === 'PsnGender') {
          if (o.required && o.optional) {
            if (!obj.sex) {
              this.$alert('Please select ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          }
        } else if (o.name === 'PsnRank') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.rank)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.rank.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckRank.test(obj.rank)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.rank && obj.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckRank.test(obj.rank) && obj.rank) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.rank = ''
          }
        } else if (o.name === 'PsnDept') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.depar)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.depar.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckDepar.test(obj.depar)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (obj.depar && obj.depar.length < 2) {
              this.$alert(o.Etitle + ' length cannot be less than 2 digits')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckDepar.test(obj.depar) && obj.depar) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.depar = ''
          }
        } else if (o.name === 'PsnCountry') {
          if (o.required && o.optional) {
            if (!obj.country) {
              this.$alert('Please select ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.country && obj.country !== 'China') {
              obj.province = ''
              obj.city = ''
            }
          }
        } else if (o.name === 'PsnEmail') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.email)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regCheckEmail.test(obj.email)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!regExp.regCheckEmail.test(obj.email) && obj.email) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.email = ''
          }
        } else if (o.name === 'PsnWebUrl') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.webUrl)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.regWebUrl.test(obj.webUrl)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!regExp.regWebUrl.test(obj.webUrl) && obj.webUrl) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.webUrl = ''
          }
        } else if (o.name === 'PsnFax') {
          if (o.required && o.optional) {
            if (!obj.faxNum || !regExp.notEmpty.test(obj.faxNum)) {
              this.$alert('请输入您的' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.faxNum.length < 7 || obj.faxNum.length > 8) &&
              obj.country === '中国大陆'
            ) {
              this.$alert('请输入7-8位的' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.faxNum.length < 5 || obj.faxNum.length > 11) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert('请输入5-11位的' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckTelCn.test(this.faxNumber) &&
              !regExp.regCheckTelEn.test(this.faxNumber)
            ) {
              this.$alert(o.Etitle + 'format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (
              obj.faxNum &&
              (obj.faxNum.length < 7 || obj.faxNum.length > 8) &&
              obj.country === '中国大陆'
            ) {
              this.$alert('请输入7-8位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.faxNum &&
              (obj.faxNum.length < 5 || obj.faxNum.length > 11) &&
              obj.country !== '中国大陆'
            ) {
              this.$alert('请输入5-11位的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.faxNum &&
              !regExp.regCheckTelCn.test(this.faxNumber) &&
              !regExp.regCheckTelEn.test(this.faxNumber)
            ) {
              this.$alert(o.title + 'format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
          }
        } else if (o.name === 'PsnTel') {
          if (o.required && o.optional) {
            if (!obj.telNum || !regExp.notEmpty.test(obj.telNum)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.telNum.length < 7 || obj.telNum.length > 8) &&
              obj.country === 'China'
            ) {
              this.$alert('Please enter 7-8 digits ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              (obj.telNum.length < 5 || obj.telNum.length > 11) &&
              obj.country !== 'China'
            ) {
              this.$alert('Please enter 5-11 digits ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              !regExp.regCheckTelCn.test(this.telNumber) &&
              !regExp.regCheckTelEn.test(this.telNumber)
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (
              obj.telNum &&
              (obj.telNum.length < 7 || obj.telNum.length > 8) &&
              obj.country === 'China'
            ) {
              this.$alert('Please enter 7-8 digits ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.telNum &&
              (obj.telNum.length < 5 || obj.telNum.length > 11) &&
              obj.country !== 'China'
            ) {
              this.$alert('Please enter 5-11 digits ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (
              obj.telNum &&
              !regExp.regCheckTelCn.test(this.telNumber) &&
              !regExp.regCheckTelEn.test(this.telNumber)
            ) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
          }
        } else if (o.name === 'PsnTrade') {
          if (o.required && o.optional) {
            if (!obj.industry) {
              this.$alert('Please select ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (!o.optional) {
            obj.industry = ''
          }
        } else if (o.name === 'PsnIDCard') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.cId)) {
              this.$alert('Please enter your ' + o.Etitle)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (obj.country === 'China' && !utils.regCId(obj.cId)) {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else {
              if (!regExp.passport1.test(obj.cId) && !regExp.passport2.test(obj.cId) && !regExp.hkmakao.test(obj.cId) && !regExp.taiwan1.test(obj.cId) && !regExp.taiwan2.test(obj.cId)) {
                console.log('456456')
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
                document.getElementsByName(o.name)[0].focus()
                return ''
              }
            }
          } else if (o.optional) {
            if (!utils.regCId(obj.cId) && obj.cId && obj.country === 'China') {
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }  else {
              if (!regExp.passport1.test(obj.cId) && !regExp.passport2.test(obj.cId) && !regExp.hkmakao.test(obj.cId) && !regExp.taiwan1.test(obj.cId) && !regExp.taiwan2.test(obj.cId)) {
                console.log('456456')
              this.$alert(o.Etitle + ' format is incorrect, please re-enter')
                document.getElementsByName(o.name)[0].focus()
                return ''
              }
            }
          } else {
            obj.cId = ''
          }
        } else if (o.name === 'PsnLoginPwd') {
          // if (o.required && o.optional) {
          //   if (!regExp.notEmpty.test(obj.password)) {
          //     this.$alert('请输入您的' + o.title)
          //     document.getElementsByName(o.name)[0].focus()
          //     return ''
          //   } else if (obj.password.length < 6) {
          //     this.$alert(o.title + '长度不能小于6位')
          //     document.getElementsByName(o.name)[0].focus()
          //     return ''
          //   } else if (!regExp.password.test(obj.password)) {
          //     this.$alert('格式填写错误,请重新输入' + o.title)
          //     document.getElementsByName(o.name)[0].focus()
          //     return ''
          //   } else if (!this.confirmPassword) {
          //     this.$alert('请再次输入密码')
          //     document.getElementsByName('confirmPassword')[0].focus()
          //     return ''
          //   } else if (obj.password !== this.confirmPassword) {
          //     this.$alert('两次输入密码不一致')
          //     document.getElementsByName('confirmPassword')[0].focus()
          //     return ''
          //   }
          // } else if (o.optional) {
          //   if (obj.password && obj.password.length < 6) {
          //     this.$alert(o.title + '长度不能小于6位')
          //     document.getElementsByName(o.name)[0].focus()
          //     return ''
          //   } else if (!regExp.password.test(obj.password) && obj.password) {
          //     this.$alert('格式填写错误,请重新输入' + o.title)
          //     document.getElementsByName(o.name)[0].focus()
          //     return ''
          //   }
          // } else {
          //   obj.password = ''
          // }
        } else if (o.name === 'PsnZipCode') {
          if (o.required && o.optional) {
            if (!regExp.notEmpty.test(obj.postcode)) {
              this.$alert('请输入您的' + o.title)
              document.getElementsByName(o.name)[0].focus()
              return ''
            } else if (!regExp.checkCnZipCode.test(obj.postcode)) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else if (o.optional) {
            if (!regExp.checkCnZipCode.test(obj.postcode) && obj.postcode) {
              this.$alert(o.title + '格式填写错误,请重新输入')
              document.getElementsByName(o.name)[0].focus()
              return ''
            }
          } else {
            obj.postcode = ''
          }
        } 
        // else if (o.name === 'PsnAddress') {
    //       if (o.required && o.optional) {
    //         if (!regExp.notEmpty.test(obj.addr)) {
    //           this.$alert('请输入您的' + o.title)
    //           document.getElementsByName(o.name)[0].focus()
    //           return ''
    //         } else if (obj.addr.length < 6) {
    //           this.$alert(o.title + '长度不能小于6位')
    //           document.getElementsByName(o.name)[0].focus()
    //           return ''
    //         } else if (!regExp.checkAddress.test(obj.addr)) {
    //           this.$alert(o.title + '格式填写错误,请重新输入')
    //           document.getElementsByName(o.name)[0].focus()
    //           return ''
    //         }
    //       } else if (o.optional) {
    //         if (obj.addr && obj.addr.length < 6) {
    //           this.$alert(o.title + '长度不能小于6位')
    //           document.getElementsByName(o.name)[0].focus()
    //           return ''
    //         } else if (obj.addr && !regExp.checkAddress.test(obj.addr)) {
    //           this.$alert(o.title + '格式填写错误,请重新输入')
    //           document.getElementsByName(o.name)[0].focus()
    //           return ''
    //         }
    //       } else {
    //         obj.addr = ''
    //       }
    //     }
      }
      if (this.privacySwitch && !this.isChecked) {
        this.$alert('Please check the privacy agreement')
        return ''
      }
      // 参展日期验证
      if (this.chooseDate.length <=0 ) {
        this.$alert('Please select a visit appointment date')
        return ''
        // this.$alert('请选择参观预约日期', `提示`, {
        //   confirmButtonText: '确定',
        //   closeOnClickModal: true,
        //   type: 'error'
        // });
        // common.themeStyleUniform();
        // return false;
      }
      // if (!this.statement1.value) {
      //   this.$alert('请勾选' + this.statement1.placeholder)
      //   return
      // }
      // if (!this.statement2.value) {
      //   this.$alert('请勾选' + this.statement2.placeholder)
      //   return
      // }
      if (this.isRepeatIDCard) { // 如果身份证号查重
        await this.checkIDCardRepeat()
      } else {
        this.idRepeatRes = true
      }
      if (this.idRepeatRes) { // 如果通过证件查重
        this.ruleForm2 = obj
        // 姓名身份证号一致性验证
        // 如果有身份证 没有国家或国家为中国大陆 进行一致性验证
        if (this.ruleForm2.cId && (this.ruleForm2.country === '中国大陆' || this.ruleForm2.country === '中国' || this.ruleForm2 === '') && this.isConsistencyIdCard === 'true') {
          utils.realNameVerification(this, this.ruleForm2.userName, this.ruleForm2.cId).then(resRealName => {
            if (resRealName === 'true') {
              if (this.previousEmail === this.ruleForm2.email) {
                this.submitInfo()
              } else {
                this.checkRepeatEmailCidCode(this.submitInfo)
              }
            } else {
              this.$alert('The name and ID number you entered are inconsistent.', 'Tips', {
                dangerouslyUseHTMLString: true
              })
            }
          })
        } else {
          if (this.previousEmail === this.ruleForm2.email) {
            this.submitInfo()
          } else {
            this.checkRepeatEmailCidCode(this.submitInfo)
          }
        }
      } else {
        this.$alert('This certificate number has been registered in this exhibition！')
      }
      return false
    },
    async checkIDCardRepeat() {
      await api.IDCardRepeat({
        exhid: sessionStorage.getItem('ExhID'),
        PsnIDCard: this.ruleForm2.cId
      }).then(res => {
        if (res.data.status === 'OK') {
          this.idRepeatRes = true
        } else {
          this.$alert(res.data.ErrorMsg, 'Tips', {
            dangerouslyUseHTMLString: true
          })
          this.idRepeatRes = false
        }
      })
    },
    getCode() {
      var num = this.ruleForm2.iphone
      if (num && regExp.regCheckCnMobile.test(num)) {
        var param = {
          exhid: this.ExhID,
          PsnMobile: num
        }
        api.mobileRepeat(param).then(res => {
          if (res.data.FaceIDstatus === 'OK') {
            // var params = {
            //   sign: '昆仑亿发',
            //   source: 'pc',
            //   token: sessionStorage.token,
            //   mobile: num
            // }
            //  $.post(api.getCodeInterface,params,function(res){
            //    if(res.data.status=="OK"){
            //      this.showCodeBtn=true;
            //      clearInterval(stop);
            //      var index=59;
            //      var stop=setInterval(function(){
            //        if(index<0){
            //          clearInterval(stop);
            //          this.codeText="获取验证码";
            //          this.showCodeBtn=false;
            //          return '';
            //        }
            //        this.codeText=index;
            //        index--;
            //      },1000);
            //    }else{
            //      this.$alert(res.data.ErrorMsg, '提示',{
            //        dangerouslyUseHTMLString: true
            //      });
            //    }
            //  });
          } else {
            this.$alert(res.data.ErrorMsg, 'Tips', {
              dangerouslyUseHTMLString: true
            })
          }
        })
      } else {
        this.$alert('Please enter the correct mobile phone number', 'Tips', {
          dangerouslyUseHTMLString: true
        })
      }
    }
  }
}
</script>
<style lang="scss">
.photoImg{
  display:inline-block;
  width:100%;
  position:relative;
  border:1px solid #DCDFE6;
  border-radius: 6px;
  padding:10px;
}
.photoImg .photoBtns{
  text-align: right;
}
.personInfobox{
  box-shadow: 0 2px 8px #c3d9eb;
  border-radius: 8px;
  overflow: hidden;
  background-color: #fff;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
input[type='number'] {
  -moz-appearance: textfield;
}
.form-item {
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 10px auto;
  position: relative;
}
.form-item.sex {
  -webkit-justify-content: flex-start;
  -ms-justify-content: flex-start;
  -o-justify-content: flex-start;
  justify-content: flex-start;
}
.form-item > div {
  min-width: 28%;
  line-height: 40px;
  text-align: right;
  padding-right: 8px;
}
.el-radio {
  line-height: 40px;
}
#personInfo {
  .el-input,
  .el-select {
    width: 86%;
  }
  .el-select .el-input {
    width: 100%;
  }
}

.from-wrap {
  box-sizing: border-box;
}
.form-item.tel{
  width: 100%;
}
.tel input {
  width: 100%;
}
.email-tip {
  position: absolute;
  width: 80%;
  left: 50%;
  top: 50px;
  transform: translate(-50%);
  z-index: 99;
}
.el-step {
  flex-basis: auto !important;
  width: 33% !important;
}
.email-tip .email-tip-option {
  word-wrap: break-word;
  margin: 10px 0;
}
.privacySwitch {
  margin: 10px 0;
  padding-left: 78px;
  display: flex;
  align-items: top;
}
.privacySwitch .privacyTxt{
  margin-left: 6px;
  font-size: 12px;
}
.privacySwitch .el-checkbox__label {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-all;
  vertical-align: top;
}
.step-box2 .el-steps {
  -webkit-justify-content: center;
  justify-content: center;
  -moz-box-pack: center;
  box-pack: center;
}
.info_content_row {
  margin-bottom: 22px;
}
.info_tit_box {
  text-align: right;
}
.info_tit {
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  text-align: right;
}
.sex_box {
  line-height: 40px;
}
.info_tips {
  margin-left: 100px;
  margin-bottom: 22px;
  color: red;
}
.el-select {
  width: 100%;
}
.info_code_btn {
  height: 40px;
  line-height: 40px;
  text-align: center;
  border-radius: 4px;
  cursor: pointer;
}
/*new --------------*/
.el-message-box {
  max-width: 80%;
}
.el-select-dropdown {
  transform-origin: center top 0px;
}
#app {
  width: 100%;
}
body {
  background: #f0f0f0;
}
.img-auto {
  width: 100%;
}
.title {
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 60px 80px 30px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.banner-box {
  width: 100%;

  margin: 0 auto;
}
.from-wrap {
  max-width: 980px;
  margin: 0 auto;
  padding: 14px;
}
.from-wrap > div {
  max-width: 580px;
  margin: 0 auto;
}
.flex {
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
  justify-content: space-between;
}
.flex-start {
  display: flex;
  justify-content: flex-start;
}
.tel .el-form-item__content {
  display: flex;
  justify-content: flex-start;
}
.code-btn {
  height: 40px;
}
.Personinfo-submit-btn {
  margin: 30px auto !important;
  display: block !important;
  width: 50%;
}

.email-tip {
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  box-sizing: border-box;

  color: #606266;
}
.email-tip .email-tip-option {
  padding: 0px 15px;
  height: 34px;
  line-height: 34px;
  text-align: left;
}
.email-tip .email-tip-option:hover {
  background: #f5f7fa;
  cursor: pointer;
}
.radioBox{
  width: 76%;
  .dateChecks{
    display: flex;
    justify-content: space-between;
    .el-checkbox-button__inner{
      padding:0.24rem 0.26rem;
      border: 0.026667rem solid #dcdfe6;
      border-radius: 4px;
    }
    .el-checkbox-button.is-checked .el-checkbox-button__inner{
      background-color: #E63468;
      border-color: #E63468;
    }
  }
  .el-radio{
    background:#efefef !important;
    border-radius:6px !important;
    padding:10px !important;
    span{
      display:block;
      padding:4px 0;
    }
    .el-radio__input{
      display:none !important;
    }
  }
  .el-radio.is-checked{
    background:rgb(230, 52, 104) !important;
  }
  .el-radio.is-checked .el-radio__label{
    color:#fff !important;
  }
  .el-checkbox-button.is-checked .el-checkbox-button__inner{
    -webkit-box-shadow: none;
    box-shadow: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/BasicInfo.vue